
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "TrueloveAndWittsCriteria",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/TrueloveAndWittsCriteria.vue